import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

/* const firebaseConfig = {
  apiKey: 'AIzaSyCPE7WYa9dYMJIGWfZZE--JcWBGErTa9Z8',
  authDomain: 'testds-f2609.firebaseapp.com',
  databaseURL: 'https://testds-f2609.firebaseio.com',
  projectId: 'testds-f2609',
  storageBucket: 'testds-f2609.appspot.com',
  messagingSenderId: '357184649979',
  appId: '1:357184649979:web:902f40d76807154c264e5e',
  measurementId: 'G-P588HC6T5B'
} */
const firebaseConfig = {
  apiKey: 'AIzaSyBrAE0nfOmzrl-G8ai8LnYg6GOE8eSziPs',
  authDomain: 'neods-c3270.firebaseapp.com',
  databaseURL: 'https://neods-c3270.firebaseio.com',
  projectId: 'neods-c3270',
  storageBucket: 'neods-c3270.appspot.com',
  messagingSenderId: '296596321637',
  appId: '1:296596321637:web:2c3f4bc73b79c549c35d8c',
  measurementId: 'G-JV45EH656J'
}

firebase.initializeApp(firebaseConfig)
// const analytics = firebase.analytics()

Vue.prototype.$analytics = firebase.analytics()

var database = firebase.database()
var storage = firebase.storage()

const store = new Vuex.Store({
  state: {
    database: database,
    storage: storage,
    clusters: null,
    playlists: null,
    devices: null,
    menus: null,
    specialOffers: null,
    pollutionTypes: null,
    weatherCities: null,
    uid: null,
    weatherApiKey: null,
    apps: null,
    playlistsArchive: null,
    menusArchive: null,
    specialOffersArchive: null,
    addOns: null,
    campaigns: null,
    powerDevices: null,
    username: null,
    role: null,
    workspaceId: null,
    items: null,
    customerSatisfaction: null,
    frontDesk: null,
    documents: null,
    questionnaires: null,
    questionnaireAnswers: null,
    appMenu: null,
    appMenuPdfs: null,
    tickets: null,

    defaultCluster: {
      extendedPlaylistId: '',
      id: '',
      menuId: '',
      mainPlaylistId: '',
      movingText: '',
      name: '',
      specialOffersMenuId: '',
      userId: ''
    },
    defaultPlaylist: {
      name: '',
      items: []
    },
    defaultMenu: {
      name: '',
      items: ''
    }
  },
  actions: {},
  getters: getters,
  mutations: mutations
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js